import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { actionTypes } from './actions'

const initialState = {}

export const reducer = persistReducer(
  {
    storage,
    key: 'panel-jobs',
    whitelist: ['walletBulkJob', 'discountGenerateJob'],
  },
  (state = initialState, action) => {
    switch (action.type) {
      case actionTypes.SET_JOB:
        return { ...state, [action.payload.key]: action.payload.job }
      case actionTypes.CLEAR_JOB: {
        const next = { ...state }
        delete next[action.payload.key]
        return next
      }
      default:
        return state
    }
  },
)
